$(document).ready(function(){
  $(document).on('click', '.itgv--slidingImages__image', function(){
    $(this).addClass('image__Active').siblings().removeClass('image__Active');
  });

  $(document).on('click', '.itgv--contentAccordian_Label .accordian__label', function(){
    $(this).siblings('.itgv--contentAccordianContent').slideToggle();
    $(this).parent().toggleClass('active');
    $(this).parent().siblings().find('.itgv--contentAccordianContent').slideUp();
    $(this).parent().siblings().removeClass('active');
  });

  $('.itgv--iconWithText__main').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    // slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  if(window.matchMedia("(max-width: 1024px)").matches){
    $('.text--with__icons .row.grid__wrapper').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  $(document).on('click', '.itgv--topCollectionFilterButton .button', function(e) {
    e.preventDefault();
    var buttonUrl = $(this).attr('href');
    $('html, body').animate({
      scrollTop: eval($(buttonUrl).offset().top - 140)
        // scrollTop: $(buttonUrl).offset().top
    }, 1000);
  });


  const links = document.querySelectorAll("#main-nav .header__nav__link"); //get all <a> elements

  links.forEach(el => { //loop trought all <a> elements
  if(!el.href.includes(window.location.hostname)){ //if not this domain
   el.setAttribute("target", "_blank");
  }
  })
  
  
});

$(document).ready(function(){
  function headerHeight() {
    var header__Height = $('.shopify-section-group-header-group.js-site-header').height();
    // header__Height = (- header__Height);
    if($('.index-sections .shopify-section:first-child').hasClass('image-with-text__section')){
      $('.index-sections .shopify-section:first-child').css('margin-top', -header__Height);
    }
  }

  headerHeight();

  $(window).resize(function(){
    headerHeight();
  });
  
});


$(window).on('scroll', function(){
   var $window = $(window),
        $body = $("body"),
        $panel = $(".ColorPanel"),
        $panelColor = "linear-gradient( 180deg, #d7dbe5 0%, rgba(255, 255, 255, 0) 75.52% )",
        scroll = $window.scrollTop() + $window.height() / 3,
        matched = false;
    $panel.each(function() {
        var $this = $(this);
        if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
            $body.removeClass(function(index, css) {});
            if ($(this).data("color")) $panelColor = $(this).data("color");
            $body.css("background-color", $panelColor);
            $body[0].style.setProperty('--itg-spline-mask-bg', $panelColor);
            matched = true;
        }
    });
    // Fallback only when no .ColorPanel matched (e.g. Related Products area on product pages).
    // Avoids overriding the panel-loop's target color with a mid-transition computed value,
    // which would desync the mask from the body's final color.
    if (!matched) {
        document.body.style.setProperty('--itg-spline-mask-bg', getComputedStyle(document.body).backgroundColor);
    }
});


  // if($('.template-collection').length){
  //   var distance = $('.itgv--collectionFilter').offset().top,
  //   $window = $(window);
  //   if($window.scrollTop() >= distance) {
  //     $('.itgv--collectionFilter').addClass('backgroundWhite');
  //   }else{
  //     $('.itgv--collectionFilter').removeClass('backgroundWhite');
  //   }
  // }

  function scrollFunctions() {
    var
        pageY = window.pageYOffset,
        tab = document.querySelector('.itgv--collectionFilter')
        // distance = document.querySelector('.itgv--collectionFilter').offset().top
        // console.log(distance);

    /** @Sticky Header **/
    if (pageY > 120) {
        tab.classList.add('backgroundWhite');
    }
    else if (pageY <=  120) {
        tab.classList.remove('backgroundWhite');
    }
  }
  
  window.addEventListener('scroll', function () {
      scrollFunctions();
  });

$(document).ready(function(){
  var bodyTop = $(document).scrollTop();
  console.log(bodyTop)
  if(bodyTop <= 100){
    var panelColor = $('.ColorPanel:first').attr('data-color');
    console.log(panelColor)
    if((panelColor).length){
      $('body').css('background-color', panelColor);
      document.body.style.setProperty('--itg-spline-mask-bg', panelColor);
    }else{
      $('body').css('background-color', '#FFF6E1');
      document.body.style.setProperty('--itg-spline-mask-bg', '#FFF6E1');
    }
  }


    $(document).on('click', '#sclmd_local_delivery #local_delivery_location_zip_button, #sclmd_shipping_method_options .sclmd_current_store_select', function(){
    // console.log('Service Checked');
    setTimeout(function() {
      var localDeliveryText = $('#sclmd_local_delivery #sclmd_valid_response .sclmd_nopickuplabel').text();
      // console.log(localDeliveryText);
      if(localDeliveryText == 'Service available.'){
        var cartTotal = $('.total .cart-original-total.cart-price').text().split('$');
        cartTotal = Number(cartTotal[1]);
        // console.log(cartTotal)
        if(cartTotal < 63){
          $('.itgv--local-deliveryPopup').fadeIn();
        }
      }
    }, 2000);
  });

  $(document).on('click', '.itgv-popupClose', function(){
    $('.itgv--local-deliveryPopup').fadeOut();
  });

  /* ITG: solo can parallax - cursor X drives front/back swap, click+drag is vertical translate */
  (function initCanAnim(){
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var dragState = null;
    var justDragged = false;
    var DRAG_THRESHOLD = 6;

    function applyParallax(el, ratio){
      var frontX = -70 + (ratio * 70);
      var backX  = -30 - (ratio * 70);
      var frontRot = -6 + (ratio * 12);
      var backRot  = 6 - (ratio * 12);
      var frontScale = 1 - (ratio * 0.08);
      var backScale  = 0.92 + (ratio * 0.12);
      var $front = $(el).find('.itg-can-anim__front');
      var $back  = $(el).find('.itg-can-anim__back');
      if (ratio > 0.5){ $front.css('z-index', 1); $back.css('z-index', 2); }
      else            { $front.css('z-index', 2); $back.css('z-index', 1); }
      $front.css('transform', 'translate(' + frontX + '%, -50%) rotate(' + frontRot + 'deg) scale(' + frontScale + ')');
      $back.css('transform',  'translate(' + backX  + '%, -50%) rotate(' + backRot  + 'deg) scale(' + backScale  + ')');
    }

    function clearInline($el){
      $el.find('.itg-can-anim__front, .itg-can-anim__back').css({ transform: '', 'z-index': '' });
    }

    $(document).on('mouseenter', '.itg-can-anim', function(){ $(this).addClass('is-active is-tracking'); });
    $(document).on('mouseleave', '.itg-can-anim', function(){
      var $el = $(this);
      $el.removeClass('is-active is-tracking is-dragging');
      clearInline($el);
      dragState = null;
    });
    $(document).on('mousemove', '.itg-can-anim', function(e){
      if (dragState && dragState.active) return;
      var rect = this.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      applyParallax(this, ratio);
    });

    $(document).on('mousedown', '.itg-can-anim', function(e){
      dragState = { el: this, startY: e.clientY, startX: e.clientX, active: false };
    });
    $(document).on('mousemove', function(e){
      if (!dragState) return;
      var dy = e.clientY - dragState.startY;
      if (!dragState.active && Math.abs(dy) < DRAG_THRESHOLD) return;
      if (!dragState.active){
        dragState.active = true;
        $(dragState.el).addClass('is-dragging').removeClass('is-tracking');
      }
      var rect = dragState.el.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      var frontX = -70 + (ratio * 70);
      var backX  = -30 - (ratio * 70);
      var frontRot = -6 + (ratio * 12);
      var backRot  = 6 - (ratio * 12);
      $(dragState.el).find('.itg-can-anim__front').css('transform',
        'translate(' + frontX + '%, calc(-50% + ' + dy + 'px)) rotate(' + frontRot + 'deg)');
      $(dragState.el).find('.itg-can-anim__back').css('transform',
        'translate(' + backX + '%, calc(-50% + ' + dy + 'px)) rotate(' + backRot + 'deg)');
      e.preventDefault();
    });
    $(document).on('click', '.itg-can-anim', function(e){
      if (justDragged) e.preventDefault();
    });
    $(document).on('mouseup', function(){
      if (!dragState) return;
      var $el = $(dragState.el);
      var wasDrag = dragState.active;
      $el.removeClass('is-dragging').addClass('is-tracking');
      clearInline($el);
      dragState = null;
      if (wasDrag){
        justDragged = true;
        setTimeout(function(){ justDragged = false; }, 50);
      }
    });
  })();

});
